// train-rfi-links.js — Link RFI iechub "Arrivi/Partenze" per stazione.
// ⚠️ File MANUALE (non rigenerato dall'import GTFS): aggiornare a mano i placeId
// se RFI li cambia. Fonte: il link "Monitor" che si apre dal sito rfi.it
// (es. Canegrate: placeId=858, Pregnana Milanese: placeId=381).
// Per le stazioni senza placeId noto si usa il fallback ?stationName=… .

const BASE = "https://iechub.rfi.it/ArriviPartenze/ArrivalsDepartures/Monitor";

/** Codice stazione Trenord → placeId RFI noto. */
export const RFI_PLACE_IDS = {
  CN_FS: 858,  // Canegrate
  PG_FS: 381,  // Pregnana Milanese
};

/**
 * URL del tabellone Arrivi/Partenze RFI.
 * - con placeId noto: `?placeId=<id>&arrivals=<bool>` (True=arrivi, False=partenze)
 * - altrimenti: ricerca per nome `?placeId=&stationName=<nome>`
 */
export function rfiMonitorUrl(stationCode, stationName, arrivals = false) {
  const pid = RFI_PLACE_IDS[stationCode];
  if (pid != null) return `${BASE}?placeId=${pid}&arrivals=${arrivals ? "True" : "False"}`;
  return `${BASE}?placeId=&stationName=${encodeURIComponent(stationName ?? "")}`;
}
